import React from 'react';

import { mergeClassNames } from '../utils';
import styles from './TextContainer.module.scss';

interface TextContainerProps {
  children: React.ReactNode;
  className: string;
}

const TextContainer = ({ children, className }: TextContainerProps) => {
  return (
    <div className={mergeClassNames(styles.container, className)}>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default TextContainer;
